const APP_ROUTES = [
  'menu',
  'perfil',
  'games',
  'wizard',
  'academy',
  'live',
  'saladejogos',
  'login',
  'register',
  'forgotpassword',
  'redefinepassword',
  'influencer',
  'admin'
]

export const GetAffiliateFromPath = (pathname = window.location.pathname) => {
  const pathSegments = String(pathname || '').split('/').filter(Boolean)

  if (pathSegments.length === 0) {
    return ''
  }

  const firstSegment = String(pathSegments[0]).trim().toLowerCase()
  if (!firstSegment || APP_ROUTES.includes(firstSegment)) {
    return ''
  }

  return firstSegment
}

export const GetRouterBasename = () => {
  const affiliateFromPath = GetAffiliateFromPath()
  return affiliateFromPath ? `/${affiliateFromPath}` : ''
}

export const VerifSubDomain = () => {
  const { hostname } = window.location
  const affiliateFromPath = GetAffiliateFromPath()

  if (affiliateFromPath) {
    return affiliateFromPath
  }

  const normalizedHostname = String(hostname || '').trim().toLowerCase().replace(/^www\./, '')

  // localhost sempre usa playcomgg
  if (normalizedHostname === 'localhost' || normalizedHostname === '127.0.0.1' || normalizedHostname === '[::1]') {
    return 'playcomgg'
  }

  const hostParts = normalizedHostname.split('.').filter(Boolean)

  // Host local custom (ex.: http://iajr:3000) usa o proprio hostname como subdominio.
  if (hostParts.length === 1) {
    return hostParts[0] || 'playcomgg'
  }

  // Subdominio local (ex.: mineiro.localhost:3000)
  if (hostParts.length === 2 && hostParts[1] === 'localhost') {
    return hostParts[0] || 'playcomgg'
  }

  // Dominio raiz sem subdominio (ex.: exemplo.com)
  if (hostParts.length === 2) {
    return 'playcomgg'
  }

  // Dominio raiz com TLD de pais (ex.: exemplo.com.br)
  const isRootDomainWithCountryTld =
    hostParts.length === 3 && hostParts[hostParts.length - 2].length <= 3
  if (isRootDomainWithCountryTld) {
    return 'playcomgg'
  }

  const subdomain = hostParts[0]
  if (!subdomain || subdomain === 'www') {
    return 'playcomgg'
  }

  return subdomain
}
  